var $ = require("jquery");
window.jQuery = $;
window.$ = $;

jQuery(
    function($)
    {
        $.each(
            [
                require('bootstrap'),
                require('slick-carousel'),
                require('ab-datepicker-locales'),
                require('ab-datepicker'),
                require('jh_magnificpopup-inline-function'),
                require('jh_magnificpopup-popup'),
                require('magnificpopup-filter'),
                // require('mindshape-cookie-hint'),
                require('shariff'),
                require('carousel-swipe'),
                require('equal-height'),
                require('slick-slider-init'),
                require('map'),
                require('xm-tools'),
                require('flipbook'),
                require('functions'),
            ],
            function() {
                if (typeof this.load === 'function') {
                    this.load();
                }
            }
        );
    }
);